import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup,} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {ApiModulesService} from 'src/app/api-modules.service';

@Component({
    selector: 'app-editpages',
    templateUrl: './editpages.component.html',
    styleUrls: ['./editpages.component.scss']
})
export class EditpagesComponent implements OnInit {
    countryname = [];
    language = [];
    channels = [];

    EditChannels: FormGroup;
    @Input() id = [];
    @Output() visibleParentPage: EventEmitter<any> = new EventEmitter<any>();

    constructor(private apiModulesService: ApiModulesService, private formBuilder: FormBuilder, private route: ActivatedRoute) {
    }

    ngOnInit() {

        this.EditChannels = this.formBuilder.group({
            owned: ['', []],
            watch_messages_for_scrapping_user: ['', []],
            message_with_image: ['', []],
            languagename: ['', []],
            countryname: ['', []]
        });


        this.editChannels();
        this.getCountriesName();
        this.getLanguage();


    }

    public getCountriesName() {
        this.apiModulesService.get('telegram/country/list').subscribe((data) => {
            this.countryname = data;
        });
    }

    public getLanguage() {
        this.apiModulesService.get('telegram/language/list').subscribe((data) => {
            this.language = data;
            console.log(this.language);
        });
    }

    public updateChannels() {
        const params: any = {};
        console.log(this.EditChannels);
        params.owned = this.EditChannels.value.owned;
        params.language_id = this.EditChannels.get('languagename').value;
        params.country_id = this.EditChannels.get('countryname').value;
        params.watch_messages_for_scrapping_user = this.EditChannels.get('watch_messages_for_scrapping_user').value;
        params.message_with_image = this.EditChannels.get('message_with_image').value;
        params.id = this.id;

        this.apiModulesService.add(params, 'telegram/channel/update_channels').subscribe((data) => {
            this.channels = data;
            //  console.log();
            this.moveToMainPage();
        });
    }

    public editChannels() {
        const params: any = {};
        params.id = this.id;
        this.apiModulesService.add(params, 'telegram/channel/edit_channels_request').subscribe((data) => {
            let channels = data;
            console.log(channels);
            this.EditChannels.setValue({
                owned: (Number)(channels.owned),
                languagename: (Number)(channels.language_id),
                countryname: (Number)(channels.country_id),
                message_with_image: (Number)(channels.message_with_image),
                watch_messages_for_scrapping_user: (Number)(channels.watch_messages_for_scrapping_user)
            });

            console.log(this.EditChannels.value);

        });
    }

    public moveToMainPage() {
        this.visibleParentPage.emit(true);

    }
}


